"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactContainerDimensions = _interopRequireDefault(require("react-container-dimensions"));

var _AlphabetSoup = _interopRequireDefault(require("./AlphabetSoup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * This component renders and animates the text as an Alphabet Soup
 * Same props as AlphabetSoup without width and height which are calculated automatically
 * @returns renders the React component
 */
const AlphabetSoupWithDimensions = props => {
  return React.createElement(_reactContainerDimensions.default, null, ({
    width,
    height
  }) => React.createElement(_AlphabetSoup.default, _extends({
    width: width,
    height: height
  }, props)));
};

var _default = AlphabetSoupWithDimensions;
exports.default = _default;